import Vue from 'vue'
import { Products } from '@one/types'
import SortingOptionCode = Products.SortingOptionCode

export class LoadedPage {
  items: Array<string> = []
  loaded: boolean = false
}

export const DEFAULT_PAGE_SIZE = 15

export class BasePagination {
  loadedPages: Record<number, LoadedPage> = {};
  totalItems: number = 0;
  totalPages: number = 0;
  pageNumber: number = 1;
  pageSize: number = DEFAULT_PAGE_SIZE;
  sortCriteria: string = SortingOptionCode.RANK_DESC;
  q: string = '*';

  addLoadedPage(pageNumber: number, page: LoadedPage) {
    Vue.set(this.loadedPages, pageNumber, page)
  }

  isLoaded(pageNumber: number) {
    return this.loadedPages[pageNumber]?.loaded ?? false
  }

  canGetPage(page: number) {
    return page <= this.totalPages && page > 0
  }

  public setSortingCriteria(criteria: SortingOptionCode) {
    this.sortCriteria = criteria
  }

  public setPageNumber(page: number) {
    this.pageNumber = page
  }

  public setPageSize(size: number) {
    this.pageSize = size
  }

  public nextPage() {
    this.pageNumber = this.pageNumber + 1
  }

  public previousPage() {
    this.pageNumber = this.pageNumber - 1
  }
}
